import { jsx as _jsx } from "react/jsx-runtime";
import GatewayUnassignmentCard from '../Card/GatewayUnassignmentCard';
function GatewayUnassignmentView(props) {
    const { contextCustomer } = props;
    return _jsx("div", { children: contextCustomer && _jsx(GatewayUnassignmentCard, { ...props }) });
}
/** @deprecated - No longer used */
export default GatewayUnassignmentView;
